// extracted by mini-css-extract-plugin
export var messageSideLeft = "_p0-1";
export var messageSideRight = "_p0-2";
export var orderLookupBubbleContainer = "_p0-0";
export var submitButton = "_p0-3";